import { Component, Input, Output, EventEmitter } from '@angular/core';
import { KvItem } from '../../core/models/kv-item';
import { SearchResult } from '../models/search-result';

@Component({
  selector: 'irar-search-results',
  template: `
  <div style="text-align:right;">
    <a *ngIf="loggedIn" routerLink="/admin/document">Add Document</a>
  </div>
  <div id="results">
    <p-dataTable [value]="results" [rows]="10" [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[10,25,50]">
      <p-column field="id" header="Id" [style]="{ 'width': '11%'}" [sortable]="true">
        <ng-template pTemplate="body" let-r="rowData">
          <span>{{r.accessionNumber}}</span>
        </ng-template>
      </p-column>
      <p-column field="title" header="Title" [sortable]="true">
        <ng-template pTemplate="body" let-r="rowData">
          <a (click)="downloadFile.emit({id: r.id, value: r.filename})" style="text-align:center;display:block;text-decoration:none;">{{r.title}}</a>
        </ng-template>
      </p-column>
      <p-column field="farm" header="Farm" [sortable]="true" [style]="{ 'width': '10%'}"></p-column>
      <p-column field="site" header="Site" [sortable]="true" [style]="{ 'width': '15%'}"></p-column>
      <p-column field="date" header="Date" [sortable]="true" [style]="{ 'width': '13%'}">
        <ng-template pTemplate="body" let-r="rowData">
          <span>{{r.date | date:'MM/yyyy':'UTC'}}</span>
        </ng-template>
      </p-column>
      <p-column *ngIf="loggedIn" [style]="{ 'width': '7%'}">
        <ng-template pTemplate="body" let-r="rowData">
          <a [routerLink]="['/admin', 'document', r.id]" style="text-align:center;display:block;">EDIT</a>
        </ng-template>
      </p-column>
    </p-dataTable>
  </div>
  <p-dialog [modal]="true" [showHeader]="false" [(visible)]="downloading">
  <div style="text-align:center">Downloading</div>
</p-dialog>
  `
})
export class SearchResultsListComponent {
  @Input() results: SearchResult[];
  @Input() downloading = false;
  @Input() loggedIn: boolean;
  @Output() downloadFile: EventEmitter<KvItem> = new EventEmitter();
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/search-results-list.ts